<template>
  <!-- Add NavBar -->
  <div
      :class="{
    'loading-blur': isLoading,
      }"
      class="w-full">
    <router-view/>
    <l-loading></l-loading>
  </div>
</template>
<script>
import LLoading from "@/components/custom/loading/LLoading";
import {mapGetters} from "vuex";
export default {
  components: { LLoading },
  computed: {
    ...mapGetters(["isLoading", "activeUser"]),
  },
  watch: {
  },
  data() {
    return {
    };
  },
  methods: {
  },
  created() {
    // Skip session restoration on SSO redirect routes — NMCheckingPage
    // handles its own auth via loginViaSSO. Firing checkLoginStatus here
    // would call /api/v1/profile/ before SSO completes, causing a 401
    // that triggers logout and redirects the user to the login page.
    if (!this.$route.meta.ssoRedirect) {
      this.$store.dispatch("checkLoginStatus");
    }
  },
};
</script>
<style lang="scss">
</style>
